const readEnvValue = (key, fallback = '') => {
  if (typeof process === 'undefined' || !process.env) {
    return fallback;
  }

  const value = process.env[key];
  return typeof value === 'string' && value.trim() ? value.trim() : fallback;
};

const normalizeIdentifier = (value) => String(value || '').trim().toLowerCase();

export const APP_CONFIG = Object.freeze({
  api: {
    baseUrl: readEnvValue('REACT_APP_API_URL', 'https://quarry-2.onrender.com'),
  },
  auth: {
    adminEmail: normalizeIdentifier(readEnvValue('REACT_APP_ADMIN_EMAIL', 'admin@admin.com')),
    legacyAdminUsername: normalizeIdentifier(readEnvValue('REACT_APP_ADMIN_USERNAME', 'admin')),
    legacyAdminPassword: readEnvValue('REACT_APP_ADMIN_PASSWORD', ''),
  },
});
